module.exports = "fonts/6ae_4KGrU7VR7bNmaYcV_3Q.woff2";